import { Component } from "../component"

export class CountryPopup extends Component {
  constructor(props) {
    super(props)
    this.temporaryMobileSelectValue = null
  }

  ui() {
    return {
      select: ".country-code",
      closeButton: ".country-popup-close",
      closeButtonStepTwo: ".country-popup-close-step-two",
      secondStep: ".country-popup-step-two",
      mobileNavVariantTwo: ".country-popup-step-two-variant-two-nav",
      applyButton: ".country-popup-step-two-apply",
      mobileSelectorItems: ".country-popup-step-two-item",
      mobileSelectorSelected: ".country-popup-step-two-selected",
      mobileCountryForm: ".country-popup-form",
    }
  }

  attachEvents() {
    const { select, applyButton, mobileSelectorItems, mobileCountryForm } =
      this.$ui

    mobileSelectorItems.forEach((item) => {
      item.addEventListener("click", (event) => {
        this.temporaryMobileSelectValue =
          event.target.getAttribute("data-value")
      })
    })

    applyButton.addEventListener("click", () => {
      select.value = this.temporaryMobileSelectValue
      mobileCountryForm.submit()
    })
  }

  created() {
    this.attachEvents()
    // this.$ui.mobileSelectorSelected.scrollIntoView()
  }
}
